export default "__VITE_ASSET__Dj3a6pUf__"